<template>
  <div class="bottom_group_bottom">
    <div
      class="bottom_group_bottom_btn btn-booking"
      :class="{'loading' : loading}"
      v-if="!!$slots.default"
    >
      <a
        href="javascript:void(0)"
        @click="loading ? ()=>{} :$emit('next')"
        class="bottom_group_btn_link js-done-booking"
      >
        <slot></slot>
      </a>
    </div>
    <div class="bottom_group_bottom_btn btn-cancel">
      <a
        href="javascript:void(0)"
        @click="loading ?  ()=>{} : $router.go(-1)"
        class="bottom_group_btn_link"
      >
        <div class="bottom_group_btn_text">戻る</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style lang="scss">
.bottom_group_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_group_bottom_btn {
  width: 80%;
  margin: 5px auto;
  border-radius: 5px;
}
.btn-booking {
  background-color: $btnColor;
}
.btn-cancel {
  background-color: #aaa;
}
/** 反転 **/
.btn-booking.active {
  background-color: $btnColor;
}
.btn-cancel.active {
  background-color: #aaa;
}
.bottom_group_btn_link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  box-sizing: border-box;
}
.btn-booking .bottom_group_btn_link {
  color: #fff;
}
.btn-cancel .bottom_group_btn_link {
  color: #fff;
}
</style>